<template>
  <div class="card card-body rounded-top">
    <component-table
      entityType="presence"
      :actions="actions"
      :columns="columns"
      :data="list"
      :total="count"
      :hideAddButton="true"
      @edit="showEditModal($event.id)"
    />

    <presence-modal :show="showModal" :players="players" :id="idToEdit" @close="hideModal" @update="update" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import PresenceModal from '@/components/modals/PresenceModal';
import ComponentTable from '@/components/table/Table';
import { listMixin } from '@/mixins/list';
import { EDIT_ACTION } from '@/utils/constants';

// @vuese
// Listy płac
// @group Fee
export default {
  name: 'presenceFeeList',
  components: { ComponentTable, PresenceModal },
  mixins: [
    listMixin('fee/presences', {
      listError: 'messages.presenceFee.listError',
      getError: 'messages.presenceFee.getError',
      added: 'messages.presenceFee.added',
      addError: 'messages.presenceFee.addError',
      updated: 'messages.presenceFee.updated',
      updateError: 'messages.presenceFee.updateError',
      deleteConfirm: 'messages.presenceFee.deleteConfirm',
      deleted: 'messages.presenceFee.deleted',
      deleteError: 'messages.presenceFee.deleteError'
    })
  ],
  data() {
    return {
      columns: [
        { name: 'scheduleContainerName', displayName: 'columns.feeName' },
        { name: 'date', displayName: 'columns.date' }
      ],
      actions: [EDIT_ACTION]
    };
  },
  computed: {
    ...mapState({
      list: state =>
        state.fee.presences.list.map(item => ({ ...item, scheduleContainerName: item.scheduleContainer.name })),
      count: state => state.fee.presences.count,
      players: state => state.team.player.list
    })
  },
  methods: {
    // @vuese
    // Pokazuje modal edycji
    showEditModal(id) {
      this.idToEdit = id;
      this.$store
        .dispatch(`presences/get`, id)
        .then(() => this.showAddModal())
        .catch(err => this.notifyError(messages.presenceFee.getError));
    }
  }
};
</script>
